export enum SystemCatCountDiscountsTypes{
    Client = 'Client',
    Resource = 'Resource',
}